import { searchWithDiacritics } from '@/helpers/searchWithDiacritics';

export const permitsFilterMixin = {
  data() {
    return {
      filteredPermits: [],
    };
  },
  watch: {
    permits: {
      immediate: true,
      handler() {
        this.filteredPermits = this.permits;
      },
    },
  },
  methods: {
    permitsFilterMethod(query) {
      this.filteredPermits = searchWithDiacritics(query, this.permits, ['name']);
    },
    handlePermitsVisibleChange() {
      setTimeout(() => {
        this.filteredPermits = this.permits;
      }, 50);
    },
  },
};
